import {
  configureStore,
  combineReducers,
  getDefaultMiddleware,
} from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import { watcherSaga } from "./sagas/rootSaga";
import dummyReducer from "./slices/user/dummySlice";
import userReducer from "./slices/user/userSlice";
import companyReducer from "./slices/company/companySlice";
import productReducer from "./slices/product/productSlice";
import groupReducer from "./slices/group/groupSlice";
import itemReducer from "./slices/item/itemSlice";
import stepReducer from "./slices/step/stepSlice";
import statisticReducer from "./slices/statistics/statisticSlice"
import ScanPrintslice from "./slices/ScanPrint/ScanPrintslice";
import { connectRouter } from "connected-react-router";
import { routerMiddleware } from "connected-react-router";
import { createBrowserHistory } from "history";

const sagaMiddleware = createSagaMiddleware();

const reducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    dummy: dummyReducer,
    user: userReducer,
    product: productReducer,
    item: itemReducer,
    step: stepReducer,
    company: companyReducer,
    group: groupReducer,
    statistics: statisticReducer,
    scan: ScanPrintslice

  });

export const history = createBrowserHistory();

const store = configureStore({
  reducer: reducer(history),
  middleware: [
    ...getDefaultMiddleware({ thunk: false, serializableCheck: false }),
    sagaMiddleware,
    routerMiddleware(history),
  ],
});
sagaMiddleware.run(watcherSaga);

export default store;
